export default (theme) => ({
    loginContainer: {
        background: theme.palette.loginScreen.loginContainer.background,
        minHeight: "100vh",
    },
    logoContainer: {
        width: "100%",
        padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
    },
    formContainer: {
        borderRadius: theme.spacing(1),
        background: theme.palette.loginScreen.formContainer.background,
        background: "white",
        padding: theme.spacing(2),
    },
});
